// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .pricing-layout {
  width: 100%;
  max-width: 1632px;
  height: auto;
  min-height: 581px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background-color: #fff;
  overflow: hidden;
  padding: 0 12px;
} */

.pricing-layout {
  width: 100%;
  max-width: 1632px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background-color: #fff;
  overflow: hidden;
  padding: 0 12px;
}

/* .inner-container {
  width: 100%;
  max-width: 1388px;
  height: auto;
  min-height: 579px;
  display: flex;
  flex-direction: column;
  gap: 10px;
} */

.inner-container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* .tier-button-container {
  width: 1388px;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  padding-right: 8px;
} */

.tier-button-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 8px;
}

/* .tier-button {
  width: 359.5px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-radius: 100px;
  border: 1px solid #838FB480;
  background: transparent;
  font-size: 16px;
  color: #838FB4;
  cursor: pointer;
  transition: all 0.2s ease;
} */

.tier-button {
  flex: 1 1 260px;
  max-width:  376px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  border-radius: 100px;
  border: 1px solid #838FB480;
  background: transparent;
  font-size: 15px;
  color: #838FB4;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 220px;
}

.tier-button.active {
  background: #f0f6fc;
  border: 1px solid #0066cc;
  color: #0066cc;
}

.tier-price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.tier-price-amount {
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  opacity: 1;
}

.tier-price-period {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  opacity: 1;
  white-space: nowrap;
}

.tier-button.active .tier-price-amount,
.tier-button.active .tier-price-period {
  color: #0066cc;
}

.tier-radio {
  width: 18px;
  height: 18px;
  border-radius: 100%;
  border: 1px solid #838fb4;
  position: relative;
  flex-shrink: 0;
}

.tier-radio.active {
  background-color: #0066cc;
  border-color: #0066cc;
}

.tier-radio.active::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 4px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: translate(-50%, -50%) rotate(-45deg);
  top: 50%;
  left: 50%;
}

/* .table-container {
  width: 1388px;
  height: 519px;
  background: #fafafa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
} */

.table-container {
  width: 100%;
  background: #fafafa;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}


/* .table-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: transform;
} */

.table-scroll {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 520px;
}

.table-scroll::-webkit-scrollbar {
  width: 6px;
}

.table-scroll::-webkit-scrollbar-thumb {
  background-color: #A3A3A3;
  border-radius: 100px;
  border: none;
}

.table-scroll {
  -ms-overflow-style: none;
  scrollbar-width: thin;
  scrollbar-color: #A3A3A3 transparent;
}

/* .feature-category-header {
  display: grid;
  grid-template-columns: 290px repeat(3, 366px);
  height: 44px;
} */
.feature-category-header,
.feature-row {
  display: grid;
  grid-template-columns: minmax(160px, 1.2fr) repeat(auto-fit, minmax(180px, 1fr));
  align-items: center;
  border-bottom: 1px solid #e4e4e4;
  min-width: 700px; /* ensures horizontal scroll on smaller screens */
}

/* .category-cell {
  width: 290px;
  height: 44px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px;
  font-size: 14px;
  background: #f6f6f6;
  color: #111111;
  border-right: 1px solid #E4E4E4;
  cursor: pointer;
} */

.category-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px;
  font-size: 14px;
  background: #f6f6f6;
  color: #111;
  border-right: 1px solid #e4e4e4;
  cursor: pointer;
}

/* .category-tier-cell {
  width: 366px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  background: #f6f6f6;
  border-right: 1px solid #E4E4E4;
} */

.category-tier-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  background: #f6f6f6;
  border-right: 1px solid #e4e4e4;
}

.category-tier-cell:last-child {
  border-right: none;
}

.category-cell.highlight,
.category-tier-cell.highlight {
  background: #E2F0FF;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: #C1E0FF;
  height: 100%;
}

/* .feature-row {
  display: grid;
  grid-template-columns: 290px repeat(3, 366px);
  height: 44px;
  border-top: 1px solid #f1f3f8;
  align-items: center;
} */

/* .feature-name {
  width: 290px;
  height: 44px;
  display: flex;
  align-items: center;
  padding: 10px 18px;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #838FB4;
  background: #FFFFFF;
  border-right: 1px solid #E4E4E4;
  text-align: left;
} */

.feature-name {
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #838FB4;
  background: #fff;
  border-right: 1px solid #e4e4e4;
}

/* .feature-value {
  width: 366px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 18px;
  gap: 10px;
  font-size: 14px;
  color: #111111;
  background: #FFFFFF;
  border-right: 1px solid #E4E4E4;
} */

.feature-value {
  padding: 10px 12px;
  font-size: 14px;
  color: #111;
  background: #fff;
  border-right: 1px solid #e4e4e4;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.feature-value:last-child {
  border-right: none;
}

.feature-value.highlight {
  background: #f0f6fc;
}

.feature-category-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.proceed-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  padding-right: 40px;
  width: 100%;
}

/* .proceed-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 35px;
  padding: 0 8px;
  background-color: #0066CC;
  color: #ffffff;
  font-size: 14px;
  box-shadow: 0px 0px 0px 0.5px #0066CC1F, 0px 1px 2.5px 0px #0066CC3D;
  cursor: pointer;
  transition: all 0.3s ease-out;
  border: none;
} */


.proceed-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 38px;
  background-color: #0066cc;
  color: #fff;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.proceed-button:hover {
  background-color: #005bb5;
}

.proceed-button:active {
  transform: translateY(1px);
}


@media (max-width: 1536px) {
  .tier-button {
    max-width: 287px;
  }
  .tier-price-amount {
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    opacity: 1;
}
}

@media (max-width: 1280px) {
  .tier-button {
    max-width: 228px;
    padding: 6px;
    font-size: 12px;
  }
  .tier-price-amount {
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    opacity: 1;
}
}

@media (max-width: 1024px) {
  .feature-category-header,
  .feature-row {
    grid-template-columns: minmax(150px, 1.5fr) repeat(auto-fit, minmax(160px, 1fr));
    min-width: 650px;
  }

  .tier-button {
    flex: 1 1 45%;
  }
}

@media (max-width: 768px) {
  .feature-category-header,
  .feature-row {
    grid-template-columns: minmax(120px, 2fr) repeat(auto-fit, minmax(140px, 1fr));
    min-width: 550px;
  }

  .tier-button-container {
    justify-content: center;
  }

  .tier-button {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .proceed-button-container {
    justify-content: center;
    padding-right: 0;
  }
}

@media (max-width: 480px) {
  .feature-category-header,
  .feature-row {
    grid-template-columns: 1fr;
    min-width: 100%;
  }

  .feature-value {
    justify-content: space-between;
  }

  .category-cell {
    font-size: 13px;
  }

  .tier-button {
    font-size: 14px;
  }

  .tier-price-amount {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PricingModel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;GAYG;;AAEH;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;;;GAOG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,+CAA+C;EAC/C,QAAQ;EACR,SAAS;AACX;;AAEA;;;;;;;;GAQG;;AAEH;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;;AAGA;;;;;GAKG;;AAEH;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;;;GAIG;AACH;;EAEE,aAAa;EACb,gFAAgF;EAChF,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;;;;;GAMG;;AAEH;;;;;;;;;;;;;GAaG;;AAEH;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;GAcG;;;AAGH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;AACA;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;AACA;;AAEA;EACE;;IAEE,gFAAgF;IAChF,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,8EAA8E;IAC9E,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* .pricing-layout {\n  width: 100%;\n  max-width: 1632px;\n  height: auto;\n  min-height: 581px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  background-color: #fff;\n  overflow: hidden;\n  padding: 0 12px;\n} */\n\n.pricing-layout {\n  width: 100%;\n  max-width: 1632px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  background-color: #fff;\n  overflow: hidden;\n  padding: 0 12px;\n}\n\n/* .inner-container {\n  width: 100%;\n  max-width: 1388px;\n  height: auto;\n  min-height: 579px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n} */\n\n.inner-container {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* .tier-button-container {\n  width: 1388px;\n  height: 50px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 7px;\n  padding-right: 8px;\n} */\n\n.tier-button-container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 0 8px;\n}\n\n/* .tier-button {\n  width: 359.5px;\n  height: 50px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-radius: 100px;\n  border: 1px solid #838FB480;\n  background: transparent;\n  font-size: 16px;\n  color: #838FB4;\n  cursor: pointer;\n  transition: all 0.2s ease;\n} */\n\n.tier-button {\n  flex: 1 1 260px;\n  max-width:  376px;\n  height: 50px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 18px;\n  border-radius: 100px;\n  border: 1px solid #838FB480;\n  background: transparent;\n  font-size: 15px;\n  color: #838FB4;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 220px;\n}\n\n.tier-button.active {\n  background: #f0f6fc;\n  border: 1px solid #0066cc;\n  color: #0066cc;\n}\n\n.tier-price {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.tier-price-amount {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 100%;\n  opacity: 1;\n}\n\n.tier-price-period {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  opacity: 1;\n  white-space: nowrap;\n}\n\n.tier-button.active .tier-price-amount,\n.tier-button.active .tier-price-period {\n  color: #0066cc;\n}\n\n.tier-radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 100%;\n  border: 1px solid #838fb4;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.tier-radio.active {\n  background-color: #0066cc;\n  border-color: #0066cc;\n}\n\n.tier-radio.active::after {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 4px;\n  border-left: 2px solid #fff;\n  border-bottom: 2px solid #fff;\n  transform: translate(-50%, -50%) rotate(-45deg);\n  top: 50%;\n  left: 50%;\n}\n\n/* .table-container {\n  width: 1388px;\n  height: 519px;\n  background: #fafafa;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n} */\n\n.table-container {\n  width: 100%;\n  background: #fafafa;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n\n/* .table-scroll {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  will-change: transform;\n} */\n\n.table-scroll {\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: 520px;\n}\n\n.table-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.table-scroll::-webkit-scrollbar-thumb {\n  background-color: #A3A3A3;\n  border-radius: 100px;\n  border: none;\n}\n\n.table-scroll {\n  -ms-overflow-style: none;\n  scrollbar-width: thin;\n  scrollbar-color: #A3A3A3 transparent;\n}\n\n/* .feature-category-header {\n  display: grid;\n  grid-template-columns: 290px repeat(3, 366px);\n  height: 44px;\n} */\n.feature-category-header,\n.feature-row {\n  display: grid;\n  grid-template-columns: minmax(160px, 1.2fr) repeat(auto-fit, minmax(180px, 1fr));\n  align-items: center;\n  border-bottom: 1px solid #e4e4e4;\n  min-width: 700px; /* ensures horizontal scroll on smaller screens */\n}\n\n/* .category-cell {\n  width: 290px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px;\n  font-size: 14px;\n  background: #f6f6f6;\n  color: #111111;\n  border-right: 1px solid #E4E4E4;\n  cursor: pointer;\n} */\n\n.category-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px;\n  font-size: 14px;\n  background: #f6f6f6;\n  color: #111;\n  border-right: 1px solid #e4e4e4;\n  cursor: pointer;\n}\n\n/* .category-tier-cell {\n  width: 366px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  background: #f6f6f6;\n  border-right: 1px solid #E4E4E4;\n} */\n\n.category-tier-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 12px;\n  background: #f6f6f6;\n  border-right: 1px solid #e4e4e4;\n}\n\n.category-tier-cell:last-child {\n  border-right: none;\n}\n\n.category-cell.highlight,\n.category-tier-cell.highlight {\n  background: #E2F0FF;\n  border-width: 0px 1px 1px 1px;\n  border-style: solid;\n  border-color: #C1E0FF;\n  height: 100%;\n}\n\n/* .feature-row {\n  display: grid;\n  grid-template-columns: 290px repeat(3, 366px);\n  height: 44px;\n  border-top: 1px solid #f1f3f8;\n  align-items: center;\n} */\n\n/* .feature-name {\n  width: 290px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  padding: 10px 18px;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #838FB4;\n  background: #FFFFFF;\n  border-right: 1px solid #E4E4E4;\n  text-align: left;\n} */\n\n.feature-name {\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #838FB4;\n  background: #fff;\n  border-right: 1px solid #e4e4e4;\n}\n\n/* .feature-value {\n  width: 366px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 18px;\n  gap: 10px;\n  font-size: 14px;\n  color: #111111;\n  background: #FFFFFF;\n  border-right: 1px solid #E4E4E4;\n} */\n\n.feature-value {\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #111;\n  background: #fff;\n  border-right: 1px solid #e4e4e4;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.feature-value:last-child {\n  border-right: none;\n}\n\n.feature-value.highlight {\n  background: #f0f6fc;\n}\n\n.feature-category-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.proceed-button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 15px;\n  padding-right: 40px;\n  width: 100%;\n}\n\n/* .proceed-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 92px;\n  height: 35px;\n  padding: 0 8px;\n  background-color: #0066CC;\n  color: #ffffff;\n  font-size: 14px;\n  box-shadow: 0px 0px 0px 0.5px #0066CC1F, 0px 1px 2.5px 0px #0066CC3D;\n  cursor: pointer;\n  transition: all 0.3s ease-out;\n  border: none;\n} */\n\n\n.proceed-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 38px;\n  background-color: #0066cc;\n  color: #fff;\n  font-size: 14px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.proceed-button:hover {\n  background-color: #005bb5;\n}\n\n.proceed-button:active {\n  transform: translateY(1px);\n}\n\n\n@media (max-width: 1536px) {\n  .tier-button {\n    max-width: 287px;\n  }\n  .tier-price-amount {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 100%;\n    opacity: 1;\n}\n}\n\n@media (max-width: 1280px) {\n  .tier-button {\n    max-width: 228px;\n    padding: 6px;\n    font-size: 12px;\n  }\n  .tier-price-amount {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 100%;\n    opacity: 1;\n}\n}\n\n@media (max-width: 1024px) {\n  .feature-category-header,\n  .feature-row {\n    grid-template-columns: minmax(150px, 1.5fr) repeat(auto-fit, minmax(160px, 1fr));\n    min-width: 650px;\n  }\n\n  .tier-button {\n    flex: 1 1 45%;\n  }\n}\n\n@media (max-width: 768px) {\n  .feature-category-header,\n  .feature-row {\n    grid-template-columns: minmax(120px, 2fr) repeat(auto-fit, minmax(140px, 1fr));\n    min-width: 550px;\n  }\n\n  .tier-button-container {\n    justify-content: center;\n  }\n\n  .tier-button {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  .proceed-button-container {\n    justify-content: center;\n    padding-right: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .feature-category-header,\n  .feature-row {\n    grid-template-columns: 1fr;\n    min-width: 100%;\n  }\n\n  .feature-value {\n    justify-content: space-between;\n  }\n\n  .category-cell {\n    font-size: 13px;\n  }\n\n  .tier-button {\n    font-size: 14px;\n  }\n\n  .tier-price-amount {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
